<template>
	<div v-if="isUserAllowedInLevel5or6" class="flex flex-col h-full">
		<div class="h-full flex flex-col" v-if="!isInitialLoading">
			<div @click="linkToDamageCase" class="cursor-pointer">
				<BaseHeader :title="isLoading ? '' : title" />
			</div>
			<div class="h-full flex flex-col">
				<div class="flex">
					<div class=" min-w-full">
						<div class="w-full h-full pr-4 pl-4 justify-start" ref="messagesRef">
							<div
								v-for="(message, index) in this.messages"
								:key="message.id"
								class="w-full flex mt-3"
								:ref="`element${message.id}`"
								:class="index === messages.length - 1 ? 'pb-5' : ''"
							>
								<div
									v-if="message.sender_type === 'App\\User'"
									class="grid grid-flow-col flex-shrink flex-row gap-3 justify-center"
									style="align-items: center"
								>
									<img
										alt="IMD Logo"
										:src="profileImage(chat.company.image)"
										class="rounded-full object-contain justify-center"
										style="align-content: center; text-align: center; width: 35px; height: 35px; object-fit: cover; background: #e4e5e4;"
									/>
									<div class="flex text-wrap align-middle bg-connectProBlue text-white justify-center rounded shadow pb-4 pt-2 pl-4 pr-4 mr-12">
										<div>
											<div class="flex flex-row">
												<div class="flex justify-start pr-1" style="font-size: 13px; align-content: end">
													{{ message.sender.first_name + ' ' + message.sender.last_name }}
												</div>
												<div class="flex justify-start" style="font-size: 13px; align-content: end">
													{{ getGermanDateTime(message.created_at) }}
												</div>
											</div>
											<div v-if="message.content !== null && message.content !== ''" style="text-align: start; white-space: pre-line">
												{{ message.content }}
											</div>
											<!--											<div v-if="message.type === 'image'">-->
											<!--												<img-->
											<!--													alt="Chat image"-->
											<!--													:src="message.file.base64content"-->
											<!--													class="flex flex-shrink object-contain justify-center mt-2"-->
											<!--													style="align-content: center; text-align: center; width: 340px; height: 200px; object-fit: cover; background: #e4e5e4;"-->
											<!--												/>-->
											<!--											</div>-->
											<!--											<div v-if="message.type === 'audio'" class="mt-2">-->
											<!--												<audio controls>-->
											<!--													<source :src="message.file.base64content" />-->
											<!--												</audio>-->
											<!--											</div>-->
											<!--											<div v-if="message.type === 'video'" class="mt-2">-->
											<!--												<video controls :src="message.file.base64content" style="max-height: 600px"></video>-->
											<!--											</div>-->
											<!--											<div v-if="message.type === 'document'" class="flex mt-2 mb-2 cursor-pointer" @click="openFile(message.file.base64content)">-->
											<!--												<div class="flex">{{ $t('document') }} {{ message.file.extension }}</div>-->
											<!--												<div class="flex-wrap ml-2">-->
											<!--													<font-awesome-icon :icon="['fas', 'download']" class="pointer-events-none" />-->
											<!--												</div>-->
											<!--											</div>-->
										</div>
									</div>
								</div>
								<div v-else class="grid grid-flow-col flex-shrink flex-row gap-3 justify-start" style="align-items: center">
									<img
										alt="IMD Logo"
										:src="profileImage(chat.customer.image)"
										class="flex flex-shrink rounded-full object-contain justify-center"
										style="align-content: center; text-align: center; width: 35px; height: 35px; object-fit: cover; background: #e4e5e4;"
									/>
									<div class="flex text-wrap align-middle bg-gray-300 text-black justify-center rounded shadow pb-1 pt-1 pl-4 pr-4 mr-12">
										<div>
											<div class="flex flex-row">
												<div class="flex justify-start pr-1" style="font-size: 13px; align-content: end">
													{{
														message.sender.company_name != null
															? message.sender.company_name
															: message.sender.first_name + ' ' + message.sender.last_name
													}}
												</div>
												<div class="flex justify-start" style="font-size: 13px; align-content: end">
													{{ getGermanDateTime(message.created_at) }}
												</div>
											</div>
											<div v-if="message.content !== ''" style="text-align: start; white-space: pre-line">
												{{ message.content }}
											</div>
											<div v-if="message.type === 'image'" class="mb-2">
												<BaseImage
													alt="Chat image"
													:src="message.file.base64content"
													:show-big="true"
													class="flex flex-shrink object-contain justify-center mt-2"
													style="align-content: center; text-align: center; width: 340px; height: 200px; object-fit: cover;"
												/>
											</div>
											<!--											<div v-if="message.type === 'audio'" class="mt-2">-->
											<!--												<audio controls>-->
											<!--													<source :src="message.file.base64content" />-->
											<!--												</audio>-->
											<!--											</div>-->
											<div v-if="message.type === 'video'" class="mt-2 mb-2 cursor-pointer" @click="loadVideo(message.id)">
												<div class="flex" v-if="message.file.base64content === undefined">Video.mp4</div>
												<LoadingSpinner :height="30" v-if="videoLoading.state && videoLoading.id === message.id" />
												<video
													controls
													v-if="message.file.base64content !== undefined"
													:src="message.file.base64content"
													style="max-height: 600px"
												></video>
											</div>
											<div v-if="message.type === 'document'" class="flex mt-2 mb-2 cursor-pointer" @click="openFile(message.file)">
												<div class="flex">{{ $t('document') }} {{ message.file.extension }}</div>
												<div class="flex-wrap ml-2">
													<font-awesome-icon :icon="['fas', 'download']" class="pointer-events-none" />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex flex-grow w-full gap-3 p-5 sticky bottom-0 fixed inset-x-0 footer bg-white">
				<div class="flex flex-shrink">
					<BaseButton class="mb-4" @click="router().go(-1)" style="min-width: 100px;">
						{{ $t('general.back') }}
					</BaseButton>
				</div>

				<BaseInput
					ref="BaseInput-message"
					class="flex w-full pr-0"
					label=""
					aria-multiline="true"
					:placeholder="$t('answer')"
					type="text"
					v-model="newMessage.content"
					:disabled="false"
				>
					<textarea
						:placeholder="$t('answer')"
						class="w-full shadow-m h-12 flex resize-none"
						style="word-break: break-word"
						v-model="newMessage.content"
						:disabled="false"
						@keydown.enter.exact.prevent="evaluateSend"
					></textarea>
				</BaseInput>
				<div class="flex flex-shrink">
					<BaseButton class="mb-4 btn-blue" :disabled="evaluateDisabled" @click="sendMessage" style="max-width: 140px;">
						{{ $t('send') }}
					</BaseButton>
				</div>
			</div>
			<router-view />
		</div>
		<LoadingSpinner v-else />
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import { ChatsApiFactory } from '@/api/generated';
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import Validate from '@/mixins/Validate';
import apiDefaults from '@/api/defaultConfiguration';
import { getDamageCaseLabel, getGermanDate, getGermanDateTime } from '@/plugins/Utils';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import router from '@/router';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import BaseImage from '@/components/forms/BaseImage.vue';
import CustomerChatMessageRepository from '@/api/repositories/CustomerChatMessageRepository';

function eventMicrophoneResult(event) {
	window.appcontainer.component.audioTrack = event.detail;
	window.appcontainer.component.newMessage.type = 'audio';
	window.appcontainer.component.onLoadFile(event.detail);
	window.removeEventListener(event.type, eventMicrophoneResult);
	window.appcontainer.component = null;
}

function eventMediaResult(event) {
	window.appcontainer.component.onLoadFile(event.detail);
	window.removeEventListener(event.type, eventMediaResult);
	window.appcontainer.component = null;
}

export default {
	name: 'ChatDetail',
	components: {
		BaseImage,
		LoadingSpinner,
		Forbidden,
		BaseInput,
		BaseHeader,
		BaseButton,
	},
	mixins: [Validate, AppContainerMixin, Authentication],
	data() {
		return {
			messages: null,
			chatID: null,
			chat: null,
			current_page: 1,
			last_page: 1,
			total: 0,
			customer: null,
			title: 'Haftpflicht-Schaden vom 15.12.2023- Max Mustermann',
			per_page: { display: '25', value: 25 },
			isLoading: true,
			isInitialLoading: true,
			interval: null,
			bla: null,
			newMessage: {
				type: 'text',
				content: '',
				chat_id: null,
			},
			buttonDisabled: true,
			file: {
				extension: '',
				base64content: '',
			},
			isAudioRecording: false,
			audioTrack: null,
			videoLoading: { state: false, id: '' },
		};
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6) {
			this.isLoading = true;
			this.chatID = this.$route.params.id;
			this.getChatInformation();
			this.getMessages();
			window.addEventListener('scroll', this.onScroll);
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
	},
	computed: {
		evaluateDisabled() {
			switch (this.newMessage.type) {
				case 'text': {
					return this.newMessage.content.length === 0;
				}
				default: {
					return this.file.base64content === null;
				}
			}
		},
	},
	methods: {
		loadVideo(messageID) {
			this.videoLoading = { state: true, id: messageID };
			new CustomerChatMessageRepository()
				.getChatMedia(messageID)
				.then(response => {
					this.messages.find(element => element.id === messageID).file.base64content = response.data.data.base64content;
					this.videoLoading.state = false;
				})
				.catch(e => {
					console.log(e);
				});
		},
		linkToDamageCase() {
			if (this.chat.subject === 'damage_case') {
				this.$router.push({ name: 'management.process.edit', params: { customer: this.chat.customer.id, processId: this.chat.damage_case.id } });
			}
		},
		evaluateSend() {
			if (this.newMessage.content.length > 1) {
				this.sendMessage();
			}
		},
		openFile(content) {
			const blob = new Blob([this.base64ToArrayBuffer(content.base64content.split(',')[1])], { type: 'application/pdf' });
			//TODO: replace with real name
			const name = 'Chat-Datei' + content.extension;
			if (this.isAppContainer) {
				const reader = new FileReader();
				reader.onload = function() {
					const arrayBuffer = this.result;
					// convert the ArrayBuffer to a comma-separated string
					const dataString = new Uint8Array(arrayBuffer).join(',');
					// send the data to Swift
					const messageData = {
						fileName: name,
						data: dataString,
					};
					// send the data to Swift
					window.webkit.messageHandlers.pdfHandler.postMessage(JSON.stringify(messageData));
				};
				reader.readAsArrayBuffer(blob);
			} else {
				const resolvingUrl = URL.createObjectURL(blob);
				const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(name)}`;

				setTimeout(function() {
					window.open(viewerUrl, '_blank');
					window.URL.revokeObjectURL(viewerUrl);
				}, 200);
			}
		},
		base64ToArrayBuffer(base64) {
			const binaryString = atob(base64);
			const bytes = new Uint8Array(binaryString.length);
			for (let i = 0; i < binaryString.length; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return bytes.buffer;
		},
		evaluateExtension(base64String) {
			const splitString = base64String.split(',')[0];
			return splitString.substring(splitString.indexOf('/') + 1, splitString.lastIndexOf(';'));
		},
		setFileType() {
			switch (this.file.extension) {
				case 'mpeg': {
					return 'audio';
				}
				case 'mp4': {
					return 'video';
				}
				case 'mov': {
					return 'video';
				}
				default:
					return 'image';
			}
		},
		toggleAudioCapture() {
			if (!this.isAudioRecording) {
				window.appcontainer.startMicrophone();
				window.appcontainer.component = this;
				window.addEventListener('microphoneResult', eventMicrophoneResult);
			} else {
				window.appcontainer.stopMicrophone();
			}
			this.isAudioRecording = !this.isAudioRecording;
		},
		onLoadFile($event) {
			this.file.base64content = $event;
			this.file.extension = this.evaluateExtension($event);
			this.newMessage.type = this.setFileType();
		},
		openUpload() {
			if (this.isAppContainer) {
				window.appcontainer.component = this;
				window.addEventListener('takeVideoResult', eventMediaResult);
				window.appcontainer.takeOrUploadMedia();
			}
		},
		chosenUpload() {
			const file = this.$refs.file.files[0];
			const reader = new FileReader();

			reader.onload = e => {
				const separatedName = file.name.split('.');
				this.file.extension = separatedName[separatedName.length - 1];
				this.newMessage.type = this.setFileType();
				this.file.base64content = e.target.result;
			};

			reader.readAsDataURL(file);
		},
		onScroll(e) {
			if (this.$refs.messagesRef?.lastElementChild != null) {
				const elementHeight = this.$refs.messagesRef.lastElementChild.scrollHeight;

				if (document.documentElement.scrollTop <= (elementHeight - 10) * 10 && !this.isLoading && this.total > this.messages.length) {
					this.isLoading = true;
					this.current_page += 1;
					this.getMessages();
				}
			}
		},
		router() {
			return router;
		},
		getGermanDateTime,
		profileImage(image) {
			if (image != null) {
				return image;
			} else {
				return require('../../../../assets/logo.png');
			}
		},
		getChatInformation() {
			if (this.chatID != null) {
				ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.chatsIdGet(this.chatID)
					.then(response => {
						this.chat = response.data.data;
						this.subject =
							this.chat.subject === 'general'
								? this.$t('general_title')
								: getDamageCaseLabel(
										this.chat.damage_case.type,
										this.chat.damage_case.license_plate,
										getGermanDate(this.chat.damage_case.created_at),
								  );
						this.title = `${this.subject} - ${
							this.chat.customer.company_name != null
								? this.chat.customer.company_name
								: this.chat.customer.first_name + ' ' + this.chat.customer.last_name
						}`;
						this.isLoading = false;
						if (this.messages != null) {
							this.isInitialLoading = false;
						}
					});
			}
		},
		sendMessage() {
			if (!this.evaluateDisabled) {
				if (this.file.base64content != null && this.newMessage.type !== 'text') {
					this.newMessage.file = this.file;
				}
				this.isLoading = true;
				this.newMessage.chat_id = this.chatID;
				ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.messagesPost(this.newMessage)
					.then(response => {
						this.messages = [];
						this.current_page = 1;
						this.newMessage.content = '';
						this.newMessage.file = null;
						this.file.base64content = '';
						this.file.extension = '';
						this.getMessages();
					});
			}
		},
		getMessages() {
			this.isLoading = true;
			ChatsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.messagesGet(this.chatID, this.current_page, this.per_page.value)
				.then(response => {
					this.last_page = response.data.meta.last_page;
					this.current_page = response.data.meta.current_page;
					this.total = response.data.meta.total;
					const newData = response.data.data.reverse();
					if (this.messages === null || this.messages.length === 0) {
						this.messages = newData;
						if (this.chat != null) {
							this.isInitialLoading = false;
						}

						this.$nextTick(() => {
							document.documentElement.scrollTo(0, 1270);
						});
					} else {
						response.data.data.reverse().forEach(element => {
							this.messages.unshift(element);
						});
					}

					// const itemName = `item_${this.messages.length-1}`
					// console.log(this.$refs.element23)
					// const a = document.getElementById(this.$refs.element23.id);
					// a.scrollTop = a.scrollHeight;

					this.$store.dispatch('updateChatsCount');
				})
				.finally(_ => {
					this.isLoading = false;
				})
				// 	.finally(_ => {
				//     this.$nextTick(() => {
				//
				//       //const a = document.getElementById('element25');
				//       console.log(this.$refs.element25.id)
				//       document.documentElement.scrollTo(0, this.$refs.element25.scrollTop);
				//     });
				//
				// })
				.catch(error => {
					this.isLoading = false;
					console.log(error);
				});
		},
	},
	watch: {
		'$store.getters.getUnreadChatsCount': function(value) {
			if (this.chatID != null) {
				const element = this.$store.getters.getUnreadChatsCount.chats.find(element => element.chat_id.toString() === this.chatID.toString());
				if (element != null) {
					if (element.count !== 0) {
						this.messages = [];
						this.current_page = 1;
						if (value !== 0 && !this.isInitialLoading) {
							this.getMessages();
						}
					}
				}
			}
		},
	},
};
</script>
